import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid } from '@mui/material';
import { IConsultant, IJob } from 'wisestep-api';
import {
  WsColors,
  WsIconActiveJob,
  WsIconLocation,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { getLocation } from '../../../candidates/utils/CandidateHelper';

interface SelctedJobCardProps {
  job?: IJob;
  consultant?: IConsultant;
  OnRemoveJob: () => void;
}
const SelectedJobCard = ({ job, consultant, OnRemoveJob }: SelctedJobCardProps) => (
  <Grid
    flexDirection="row"
    item
    xs={5.95}
    display="flex"
    bgcolor={WsColors.Green100}
    p={1}
    borderRadius={2}
    alignItems="center"
  >
    <Grid item container xs={11} display="flex" alignItems="center" columnGap={1}>
      <WsIconActiveJob />
      <WsTypography variant={WsTypoVariants.TITLE} bold>
        {job?.title ?? consultant?.name ?? 'Not Available'}
      </WsTypography>

      <Box pl={1}>
        <WsIconLocation />
      </Box>
      <WsTypography variant={WsTypoVariants.BODY1}>
        {(job?.locations && getLocation(job?.locations?.[0])) ??
          (consultant?.locations && getLocation(consultant?.locations?.[0])) ??
          'Not Available'}
      </WsTypography>
    </Grid>
    <Grid item xs={1} justifyContent="flex-end">
      <CloseIcon cursor={'pointer'} onClick={OnRemoveJob} />
    </Grid>
  </Grid>
);
export default SelectedJobCard;
